export default __webpack_public_path__ + "static/media/top-border-2.f119a992.svg";